import React from 'react'

//Import Css.
import './slideCardsSoporte.css'


export function SlideCardsSoporte({iconSoporte, titleSoporte, textSoporte}) {
    return(
    

        <div className='box-card-soporte-slide'>
            
            <div className='box-icon-title-soporte-slide'>
                <img className='icon-soporte-slide' src={iconSoporte}/>    
                <h3 className='title-soporte-slide'>{titleSoporte}</h3>
            </div>    

            <div className='box-text-soporte-slide'>
                <p className='text-soporte-slide'>{textSoporte}</p>
            </div>
        
        </div>



    );
}